import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  KEYWORDS: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  KEYWORDS_CHART: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/chart`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  COMPETITORS_CHART: ({ commit, dispatch }, { projectId, keywordId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/${keywordId}/compare`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_KEYWORDS: ({ commit, dispatch }, {projectId, keywords}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords`, { keywords: keywords }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_KEYWORDS: ({ commit, dispatch }, {projectId, keywordsIds}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/delete`, { keyword_ids: keywordsIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_SEO_KEYWORDS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/my-seo-keywords/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {'keyword_name': str, 'engine_id': int}
  SEARCH_KEYWORD: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/keyword-volume-search`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {'domain': str, 'engine_id': int}
  SEARCH_DOMAIN: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/domain-volume-search`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {'keyword_names': [str], engine_id: int, relevant_domain: str} (Note: relevant_domain should be presented at least as empty string)
  ADD_SEO_KEYWORDS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/my-seo-keywords/add-many`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {'keyword_name': str?, 'engine_id': int?, 'relevant_domain: str?'} (Note: to "delete" relevant_domain put empty string)
  EDIT_SEO_KEYWORD: ({ commit, dispatch }, {keywordId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/my-seo-keywords/${keywordId}`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_SEO_KEYWORD: ({ commit, dispatch }, keywordId) => {
    return new Promise((resolve, reject) => {
      Vue.http.delete(`${apiUrl}${version}/my-seo-keywords/${keywordId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_RANKING_DIAGRAM: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/ranking-diagram`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: из url
  // engine_id: int
  // top_position_type: int (0 - Top3, 1 - Top4to10, 2 - Top11to50)
  GET_KEYWORDS_TOP_POSITIONS_CHART: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords-ranking-top-position`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/keyword/actions.js